module.exports = function toggleRetired() {
	var isretired = window.jQuery('#isretired').is(':checked');

	if (isretired) {
		// if we're retired we can't demand employment information
		window.jQuery('#employer').removeAttr('isRequired').val('');
		window.jQuery('#title').removeAttr('isRequired').val('');
	} else {
		// see if you can restore visible/required state on employer and title fields
		if(window.jQuery('#employer').data('visiblevalidation') === 'required') {
			window.jQuery('#employer').addClass('isRequired');
			window.jQuery('#title').addClass('isRequired');
		}
	}

};
